import { useState } from "react";
import Logo from "./components/Logo";
import NavModule from "./components/NavModule";
import LogoutButton from "./components/LogoutButton";
import { SIDEBAR_MODULES } from "./config/sidebarConfig";

/**
 * Admin Sidebar Component
 * Collapsible navigation sidebar with smooth transitions
 */
const Sidebar = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <nav
      className={`h-screen flex flex-col bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] text-white font-Poppins shadow-2xl transition-all duration-300 relative ${
        isCollapsed ? "w-[80px]" : "w-[260px]"
      }`}
      style={{
        boxShadow:
          "4px 0 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.05)",
      }}
    >
      {/* Subtle overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col h-full">
        {/* Logo Section */}
        <Logo isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />

        {/* Navigation Modules - Scrollable with hidden scrollbar */}
        <div
          className="flex-1 overflow-y-auto py-4"
          style={{
            scrollbarWidth: "none" /* Firefox */,
            msOverflowStyle: "none" /* IE and Edge */,
          }}
        >
          <style jsx>{`
            div::-webkit-scrollbar {
              display: none; /* Chrome, Safari, Opera */
            }
          `}</style>
          {Object.entries(SIDEBAR_MODULES).map(([key, module]) => (
            <NavModule
              key={key}
              module={module}
              hoveredItem={hoveredItem}
              setHoveredItem={setHoveredItem}
              isCollapsed={isCollapsed}
            />
          ))}
        </div>

        {/* Logout Button */}
        <LogoutButton
          hoveredItem={hoveredItem}
          setHoveredItem={setHoveredItem}
          isCollapsed={isCollapsed}
        />
      </div>
    </nav>
  );
};

export default Sidebar;
